// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"f9b0fef8","1227":"f9b0fef8","1388":"70b98329","2199":"f9b0fef8","2464":"7aaf09fe","3488":"f9b0fef8","5281":"7ac6a1a1","6327":"f9b0fef8","9226":"f9b0fef8","9407":"f9b0fef8"}[chunkId] + ".chunk.css";
};